/** Format IANA timezone as UTC offset, e.g. UTC+8 or UTC+5:30. */
export function formatTimezoneUtcOffset(timeZone: string): string {
  if (!timeZone || timeZone === 'UTC' || timeZone === 'Etc/UTC') {
    return 'UTC';
  }

  try {
    const offsetPart = new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'shortOffset',
    })
      .formatToParts(new Date())
      .find(part => part.type === 'timeZoneName')?.value;

    if (!offsetPart || offsetPart === 'GMT' || offsetPart === 'UTC') {
      return 'UTC';
    }

    return offsetPart.replace(/^GMT/, 'UTC');
  } catch {
    return timeZone;
  }
}

/** e.g. "UTC+8 (Singapore)" — offset primary, city kept for uniqueness. */
export function formatTimezoneOptionLabel(
  timeZone: string,
  cityLabel?: string,
): string {
  const offset = formatTimezoneUtcOffset(timeZone);
  if (!cityLabel || cityLabel === 'UTC' || cityLabel === offset) {
    return offset;
  }
  return `${offset} (${cityLabel})`;
}
